import './PullmanSanAndreasPrivacyPolicy.css';

import { AppData } from '../../../../services';
import GoogleMapReact from 'google-map-react';
import PullmanBanners from '../components/PullmanBanners';
import React from 'react';
import ThemeSixOfficeSection from '../components/ThemeSixOfficeSection';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';
import KuposHelmet from '../../../common/KuposHelmet';
import ThemeThreeTitle from '../../ThemeThree/common/ThemeThreeTitle';

const AnyReactComponent = ({ img }) => (
  <div>
    <img
      style={{
        display: 'inline-block',
        width: '20px',
      }}
      alt=""
      src={img}
    />
  </div>
);

function PullmanSanAndreasPrivacyPolicy({ home }) {
  const operator = home.operator ? home.operator : '';

  const createMarkup = data => {
    return { __html: data };
  };

  return (
    <div className="pullman-san-andreas-contact">
      <PullmanBanners
        bgImage={getIcons('contactBanner')}
        text={'Políticas de Privacidad'}
        textPosition={'center'}
      />
      <KuposHelmet />
      <div className="new-container">
        <ThemeThreeTitle operator={operator} title="Políticas de privacidad" />

        <div
          dangerouslySetInnerHTML={createMarkup(
            operator && operator.privacy_policy ? operator.privacy_policy : '',
          )}
          className="lh-1-3 terms-and-conditions"
          style={{ fontSize: '13px' }}
        />
      </div>

      {/* <div className="new-container">
        <div className="main-heading">
          Términos <span className="bold-text">Generales</span>{' '}
        </div>
        <div className="privacy-item">
          Las presentes políticas de privacidad (en adelante denominadas las “Políticas”)
          representan las condiciones de uso; políticas de privacidad y protección de datos en lo
          que refiere a la recolección y divulgación de información personal dentro de la plataforma
          y en la aplicación móvil para Android y iOS; todas plataformas administradas, operadas,
          propiedad y responsabilidad de Pullman San Andrés, de ahora en adelante referido como el
          Operador.
        </div>
        <div className="privacy-item">
          El Operador se reserva el derecho de modificar las presentes Políticas sin previo aviso,
          con el fin de adaptarlas a novedades o requerimientos legislativos; actualización que será
          anunciada a través de las plataformas que conforman el Sitio Web.
        </div>

        <div className="main-heading bold-text">1- Aceptación de condiciones de uso</div>
        <div className="privacy-item">
          a- La utilización y contratación de servicios a través de las plataformas y aplicaciones
          que conforman el Sitio Web del Operador, el usuario acepta y reconoce de su conocimiento y
          aceptación de las Políticas. Es responsabilidad del Usuario la lectura previa,
          entendimiento y aceptación de estas Políticas cada vez que sea utilizada cualquiera de las
          plataformas del Sitio Web.
        </div>

        <div className="main-heading bold-text">2- Identificación y autorización de usuarios</div>
        <div className="privacy-item">
          a- Los servicios ofrecidos se dividen en dos grupos: Un primer grupo que no requiere
          registro de usuario obligatorio para su utilización y compra; y un segundo grupo que sí
          requiere registro de usuario obligatorio.
        </div>
        <div className="privacy-item">
          b- El Usuario tiene la facilidad de registrar una cuenta personal en el Sitio Web. Dicha
          Cuenta de usuario estará vinculada con su RUT o número de identificación, dirección de
          correo electrónico y número telefónico.
        </div>
        <div className="privacy-item">
          c- Es de exclusiva responsabilidad del Usuario el mantener la confidencialidad de su
          cuenta, su contraseña y de restringir el acceso a su ordenador o dispositivos con el fin
          de evitar accesos no autorizados a su Cuenta registrada. En caso de tener algún motivo
          para creer que su contraseña o cuenta está siendo utilizada por otra persona, es
          responsabilidad del Usuario el comunicarse e informar de manera inmediata al Operador. El
          Operador no será responsable por pérdidas en las que el Usuario pueda incurrir debido a
          accesos o credenciales compartidas de su cuenta registrada.
        </div>
        <div className="privacy-item">
          d- El Usuario entiende y acepta que, al momento de registrar una Cuenta en el Sitio Web
          usando una cuenta personal (En adelante denominada la “Cuenta personal”) en cualquier red
          social, consiente expresamente que el Operador (i) Tenga acceso, en cualquier momento, a
          la totalidad de la información contenida en su Cuenta personal, incluyendo pero no
          limitados a: sus Datos Personales, información sobre sus intereses, gustos, contactos y
          cualquier otro contenido alojado en su Cuenta personal; (ii) Incluya en dicha Cuenta
          personal mensajes, fotografías, videos y cualquier otro tipo de contenido; (iii) Envíe al
          correo electrónico del Usuario vinculado a la Cuenta Personal o al correo electrónico
          utilizado para realizar compras en el Sitio Web, información o mensajes relacionados a sus
          compras y transacciones dentro de las plataformas que conforman el Sitio Web.
        </div>

        <div className="main-heading bold-text">3- Recolección de datos</div>
        <div className="sub-heading">a- Datos proporcionados por el usuario:</div>
        <div className="privacy-item">
          La utilización y contratación de servicios a través del Sitio Web requiere la entrega de
          parte del Usuario de ciertos datos de carácter personal (en adelante denominados los
          “Datos personales”), los cuales incluyen información como: Nombre y apellido, número de
          cédula de identidad o pasaporte, nacionalidad, información de contacto (número de
          teléfono, domicilio o dirección de correo electrónico). Adicionalmente, en casos de
          cancelación de compras, la plataforma requiere la entrega de parte del Usuario de
          información personal bancaria como: Banco, tipo de cuenta y número de cuenta; la cual
          permite procesar el reembolso correspondiente a la cancelación.<br></br>
          <br></br>
          Es responsabilidad del Usuario el proporcionar al Operador datos correctos, exactos y
          actuales. En caso de equivocaciones por parte del Usuario, el Operador no tiene ninguna
          responsabilidad por la corrección ni verificación de los datos proporcionados. Es potestad
          del Usuario la entrega de la información solicitada. En caso de no entregar la información
          básica necesaria para el proceso de compra de servicios, el Usuario no podrá comprar en
          las plataformas que conforman el Sitio Web.<br></br>
          <br></br>
          En caso de realizar reservas en nombre de terceros, el Usuario debe contar con el
          consentimiento previo de dicho tercero antes de facilitar Datos personales de éste. Si el
          tercero es menor de edad según la ley aplicable, el Usuario declara tener facultades
          suficientes para entregar dichos Datos personales y aceptar las Políticas en su nombre. El
          usuario puede también, voluntariamente, responder encuestas y facilitar opiniones,
          sugerencias, reclamos o comentarios (en adelante denominadas las “Opiniones”) a través de
          los correos electrónicos enviados desde la plataforma para este propósito. En caso de
          responder estas encuestas, el Usuario entiende y acepta que el Operador puede publicar y
          mostrar estas opiniones en cualquiera de las plataformas que conforman el Sitio Web o en
          otras plataformas y/o aplicaciones con las que el Operador tenga relaciones contractuales.
          Al responder estas encuestas, el Usuario cede de manera irrevocable al Operador todos los
          derechos de propiedad sobre estas opiniones y fotografías. El usuario entiende y acepta
          que, al compartir información en un área pública del Sitio Web, esta información queda a
          disposición de otros miembros, usuarios del Sitio Web y público en general. El Operador no
          se hace responsable por opiniones y comentarios compartidos por el Usuario y que sean
          utilizados por otros usuarios del Sitio Web o público general para otros fines.
        </div>

        <div className="sub-heading">b- Datos proporcionados por terceros:</div>
        <div className="privacy-item">
          En la medida permitida por la ley, el Operador también puede obtener Datos personales y
          complementar los Datos personales entregados previamente por el Usuario, ya sea a través
          de entidades afiliadas, socios comerciales y otras fuentes terceras independientes como:
          bases de datos públicas, información recopilada durante conversaciones telefónicas con el
          equipo de atención al cliente y/o a través de aplicaciones interactivas.<br></br>
          <br></br>
          Todos los Datos personales obtenidos por el Operador por cualquier medio descrito en estas
          Políticas serán tratados de conformidad con las disposiciones de esta Política de
          Privacidad y la ley.
        </div>

        <div className="main-heading bold-text">
          4- Utilización de los datos recolectados de los usuarios y de terceros
        </div>
        <div className="privacy-item">
          a- La recolección y tratamiento de los Datos personales recolectados, sean proporcionados
          por El Usuario o por terceros, tiene como finalidad el mantenimiento de la relación
          comercial establecida en la compra de servicios de parte del Usuario en las plataformas
          que conforman el Sitio Web. Con ésta se espera:<br></br>
          <br></br>
          Gestionar, administrar y brindar soporte a las compras realizadas por el Usuario en las
          plataformas del Operador.<br></br>
          <br></br>
          Enviar o informar al Usuario sobre actualizaciones o cambios en sus compras o servicios
          adquiridos a través de las plataformas del Operador. Esta información podrá ser enviada
          vía correo electrónico, SMS o Whatsapp al número de teléfono registrado por el Usuario al
          momento de registrarse o de realizar su compra.<br></br>
          <br></br>
          Enviar encuestas y solicitudes de datos con la finalidad de recopilar información,
          opiniones, sugerencias o reclamos sobre los servicios comprados por el Usuario y la
          calidad de los mismos.
        </div>

        <div className="main-heading bold-text">
          5- Almacenamiento de información y transferencia de datos
        </div>
        <div className="privacy-item">
          a- Al utilizar el Sitio Web, el Usuario entiende y acepta que el Operador recopila y
          almacena automáticamente cierta información sobre la actividad de sus Usuarios, incluyendo
          pero no limitado a; (i) la URL de la que provienen (estén o no en el Sitio Web del
          Operador); (ii) a qué URL acceden después de navegar en el Sitio Web; (iii) qué navegador
          están utilizando al momento de ingresar al Sitio Web; (iv) la dirección IP desde la cual
          están ingresando al Sitio Web; (v) Las páginas visitadas y las búsquedas recientemente
          realizadas. El usuario entiende y acepta que, para que el Sitio Web funcione
          correctamente, el Operador utiliza cookies propias y de terceros.<br></br>
          <br></br>
          b- Todos los Datos personales son recolectados y almacenados en servidores ubicados
          físicamente en Estados Unidos de Norteamérica. El Operador se reserva el derecho de
          reubicar estos mismos datos en servidores en otros países con fines de respaldo o back-up.
          El Operador se compromete a garantizar que se cumplan los estándares legalmente
          establecidos para la protección y resguardo de los Datos personales, mediante la firma de
          acuerdos o convenios cuyo objeto sea la privacidad de los mismos.<br></br>
          <br></br>
          c- Los Datos Personales serán tratados con el grado de protección legalmente exigible para
          garantizar la seguridad de los mismos y evitar su alteración, pérdida, tratamiento o
          acceso no autorizado. El Operador resguarda los Datos personales de acuerdo a los
          estándares y procedimientos de seguridad y confidencialidad en conformidad con lo
          establecido en la ley 19.628 sobre Protección de la Vida Privada y demás normas
          relacionadas.
        </div>

        <div className="main-heading bold-text">6- Intercambio de información personal</div>
        <div className="privacy-item">
          a- El Operador no transmite, divulga o proporciona Datos personales recopilados de
          usuarios o a través de terceros a ningún tercero diferente del titular de dichos Datos
          personales y/o aquellos descritos en las presentes Políticas. Lo anterior, sin perjuicio
          de nuestra obligación de proporcionar información a requerimiento de alguna autoridad
          administrativa o judicial y cuando así lo exige la ley en situaciones concretas y
          específicas; que impliquen:<br></br>
          <br></br>
          Cumplir con lo dispuesto en la ley, reglamento, procedimiento legal o peticiones
          gubernamentales aplicables..<br></br>
          <br></br>
          Hacer cumplir las Condiciones de Uso del Servicio, incluyendo la investigación de posibles
          irregularidades.<br></br>
          <br></br>
          Detectar, prevenir, o de cualquier modo abordar posibles fraudes, fallas de seguridad o
          temas técnicos.
        </div>

        <div className="main-heading bold-text">7- Seguridad</div>
        <div className="privacy-item">
          a- El Sitio Web cuenta con las medidas de seguridad y protección contra pérdida o
          alteración de información con el uso de codificación Secure Socket Layer (SSL) o capa de
          puertos seguros.
        </div>

        <div className="main-heading bold-text">8- Concursos y promociones</div>
        <div className="privacy-item">
          a- En caso de que el Operador sea anfitrión o patrocine concursos, actividades especiales,
          promociones, regalos, sorteos, rifas o descuentos; cuyas actividades requieran la
          recolección de datos de contacto de los ganadores o usuarios participantes, esta
          información será tratada de acuerdo a las mismas cláusulas y condiciones estipuladas en
          estas Políticas.
        </div>

        <div className="main-heading bold-text">
          9- ¿Cómo puedes controlar los datos personales que has ingresado en el Sitio Web?
        </div>
        <div className="privacy-item">
          a- Como usuario tienes derecho a revisar los datos que mantiene el Operador sobre ti, en
          cualquier momento. En caso de que tengas una solicitud de revisión sobre la privacidad de
          tus datos, así como de eliminar o acceder a tu información, debes enviar un correo a
          amit.sodani@pasajebus.com. Una vez sea enviada la solicitud, nuestro equipo de privacidad
          se comunicará directamente para asistir en la solicitud. Consultas generales de privacidad
          de datos o cualquier otra relacionada a las Políticas de Privacidad y Cookies, deben ser
          dirigidas a cecilia.castro@pasajebus.com o amit.sodani@pasajebus.com.
        </div>

        <div className="main-heading bold-text">
          10- ¿Qué tipo de datos o información personal guarda el Operador y por qué?
        </div>
        <div className="privacy-item">
          a- El Operador no puede ofrecerte la mejor alternativa de viaje sin información, por lo
          que al usar nuestros servicios, hay algunos datos que te pedimos. Los datos solicitados
          son información típica o de rutina: tu nombre, datos de contacto, los nombres de las
          personas que viajan contigo y, en algunos escenarios, tu información de pago.<br></br>
          <br></br>
          Adicionalmente a esto, también recopilamos información acerca del dispositivo (computador,
          teléfono, tablet u otro) que utilices para acceder a nuestros servicios. Esto incluye la
          dirección IP, el navegador que utilizas, el ID de tu teléfono y tus preferencias de idioma
          o lenguaje. También, y dependiendo de los servicios, permites que recopilemos la siguiente
          información: tu foto de perfil, género, fecha de nacimiento. Algunas de las llamadas o
          comunicaciones escritas que hagas a nuestros canales de atención podrían ser grabadas con
          motivo de capacitación y supervisión; así como cualquier información extraordinaria que
          hayas decidido compartir con nosotros al momento de usar nuestros servicios, como tu
          ubicación, calendario y otros.<br></br>
          <br></br>
          El principal objetivo detrás de la recolección de estos datos es únicamente el mejorar y
          ofrecerte una experiencia más amigable en el Sitio Web, en cualquiera de sus versiones.
        </div>
      </div> */}
    </div>
  );
}
/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
    common: state.common,
  };
}

export default connect(mapStateToProps)(PullmanSanAndreasPrivacyPolicy);



// WEBPACK FOOTER //
// ./src/features/themes/theme6/PullmanSanAndreasPage/PullmanSanAndreasPrivacyPolicy.js